import React, { FunctionComponent } from 'react';

import './styles/success-view.scss';

interface SuccessViewProps {
  assetCount: number;
  shareLink: string;
  shareLinkName: string;
}

export const SuccessView: FunctionComponent<SuccessViewProps> = ({
  assetCount,
  shareLink,
  shareLinkName,
}) => {
  const assetCopy = assetCount === 1 ? bfTranslate('asset') : bfTranslate('assets');

  return (
    <div className="submission-success">
      <h1 className="submission-success__title">
        <span className="bff-check-mark icon" />
        {bfTranslate('Success!')}
      </h1>
      <p
        className="submission-success__copy"
      >
        <span>{assetCount}</span>
        <span>{assetCopy}</span>
        <span>{bfTranslate('successfully added to Share Link:')}</span>
        <a
          className="share-link-link"
          href={shareLink}
          rel="noreferrer noopener"
          target="_blank"
        >
          {shareLinkName}
        </a>
      </p>
    </div>
  );
};
